export enum PaymentPlanType {
	NotSet = -1,
	Recurring = 1,
	Autopay = 2,
	Installment = 3
}
